// ── Auth ─────────────────────────────────────────────────────────────────────

const AUTH_TRANSLATIONS = {
  register: 'Inscription',
  'login.dashboard': 'Connexion tableau de bord',
  'login.secufireaction': 'Connexion Secufire Action',
  'login.secufireAction': 'Connexion Secufire Action',
  'auth.login.secufireaction': 'Connexion Secufire Action',
  'auth.login.secufireAction': 'Connexion Secufire Action',
  secufireaction: 'Connexion Secufire Action',
  secufireAction: 'Connexion Secufire Action',
  logout: 'Déconnexion',
  profile_update: 'Mise à jour du profil',
  password_change: 'Changement de mot de passe',
  admin_update: "Modification d'un utilisateur par administrateur",
  user_deleted: "Suppression d'un utilisateur",
  created_by_admin: 'Compte utilisateur créé par un administrateur',
  created_user: 'Utilisateur créé sous la supervision de cet administrateur',
  admin_supervisor_assigned: 'Superviseur assigné',
  admin_supervisor_unassigned: 'Superviseur retiré',
  bulk_email: "Envoi d'e-mails groupés",
  admin_hierarchy_shared: 'Hiérarchie partagée',
};

// ── Historic Fire ─────────────────────────────────────────────────────────────

const HISTORIC_FIRE_TRANSLATIONS = {
  list_fires: 'Liste des feux historiques',
};

// ── DFCI Service ─────────────────────────────────────────────────────────────

const DFCI_TRANSLATIONS = {
  'dfci.get_by_zoom': 'Quaddrillage DFCI',

  electric_line_view: 'Lignes électriques',

  electric_station_view: 'Stations électriques',

  fire_station_view: "Centres d'incendie et de secours (SDIS)",

  'gaz_line.get_all': 'Lignes principales de gaz',

  'gaz_car_station.get_all': 'Stations de ravitaillement en gaz',

  'railways.get_all': 'Chemins de fer',

  'railways_view': 'Chemins de fer',
  // 'railways_stations_view': 'Stations de fer',
  // 'railways.get_stations': 'Chemins de fer',

  'road.get_major': "Routes/ chemins d'accès",

  'road.get_secondary': "Routes/ chemins d'accès",

  road_tile_view: "Routes/ chemins d'accès",

  get_residential: 'Zones urbaines',

  swimming_pool_tile_view: "Points d'eau artificiels",

  'zone.department.tile.view':
    'Limites administratives des départements',
};

// ── Physical Model ────────────────────────────────────────────────────────────

const PHYSICAL_MODEL_TRANSLATIONS = {
  // Propagation
  run_dynamic: 'Propagation réelle',
  run_simulation: 'Propagation simulée',

  // Streaming / affichage
  stream_dynamic: 'Propagation réelle',
  stream_simulation: 'Propagation simulée',

  // Clés génériques
  // dynamic: 'Propagation réelle',
  // simulation: 'Propagation simulée',

  // Historique
  run_historic: "Historique d'événements",
  historic: "Historique d'événements",
};

// ── Vegetation Service ────────────────────────────────────────────────────────

const VEGETATION_TRANSLATIONS = {
  baresoil: 'Sol nu',
  biomass: 'Biomasse',
  broadleaf: 'Forêts de feuillus',
  coniferous: 'Forêts de conifères',
  cropland: 'Zones agricoles',
  dem: 'Modèle numérique du terrain',
  fuel_load: 'Charge totale de combustible',
  grassland: 'Strate herbacée',
  chm: 'Hauteur de végétation',
  lai: 'Indice de surface foliaire',
  mixed_forest: 'Forêt mixte',
  oak: 'Chêne',
  pin: 'Pin',
  shrubland: 'Strate arbustive',
};

// ── Weather Service ───────────────────────────────────────────────────────────

const WEATHER_TRANSLATIONS = {
  dfmc: 'Humidité des combustibles morts',
  precipitation_1h: 'Précipitations horaires cumulées',
  precipitation_3h: 'Précipitations sur 3h',
  pr2msl: 'Pression au niveau de la mer',
  precipitation_6h: 'Précipitations sur 6h',
  relative_humidity: 'Humidité relative',
  temperature: 'Température',
  total_precipitation: 'Précipitation totale',
  wind_direction: 'Direction du vent',
  wind_gust: 'Vitesse des rafales de vent',
  wind_speed: 'Vitesse du vent',
  soil_moisture: 'Humidité du sol',
};

// ── Active Fire Service ──────────────────────────────────────────────────────

const ACTIVE_FIRE_TRANSLATIONS = {
  list_active_fires: 'Points chauds',
};

// ─────────────────────────────────────────────────────────────────────────────
// Map microservice → dictionnaire de traductions
// ─────────────────────────────────────────────────────────────────────────────

const MS_TRANSLATION_MAP = {
  auth: AUTH_TRANSLATIONS,

  'historic-fire_service': HISTORIC_FIRE_TRANSLATIONS,
  historic_fire: HISTORIC_FIRE_TRANSLATIONS, // alias

  dfci_service: DFCI_TRANSLATIONS,

  physical_model: PHYSICAL_MODEL_TRANSLATIONS,

  vegetation_service: VEGETATION_TRANSLATIONS,

  weather_service: WEATHER_TRANSLATIONS,

  active_fire_service: ACTIVE_FIRE_TRANSLATIONS,
};

// ─────────────────────────────────────────────────────────────────────────────
// Traductions des noms de microservices eux-mêmes
// ─────────────────────────────────────────────────────────────────────────────

export const MS_LABELS = {
  auth: 'Authentification',

  'historic-fire_service': 'Historiques des feux',
  historic_fire: 'Historiques des feux', // alias

  dfci_service: 'Analyse terrain',

  physical_model: 'Modèle physique',

  vegetation_service: 'Végétation',

  weather_service: 'Météo',

  active_fire_service: 'Points chauds',
};

// ─────────────────────────────────────────────────────────────────────────────
// Fonctions utilitaires
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Traduit un endpoint/fonctionnalité dans le contexte d'un microservice donné.
 *
 * @param {string} endpoint
 * @param {string} microservice
 * @returns {string}
 *
 * @example
 * translateEndpoint('wind_speed', 'weather_service')
 * // → "Vitesse du vent"
 *
 * translateEndpoint('login.dashboard', 'auth')
 * // → "Connexion tableau de bord"
 */
export const translateEndpoint = (endpoint, microservice) => {
  if (!endpoint) return '—';

  const normalizedMs = microservice?.toLowerCase().trim() || '';
  const dict = MS_TRANSLATION_MAP[normalizedMs] || {};

  const key = endpoint.toLowerCase().trim();

  // 1. Correspondance exacte
  if (dict[key]) return dict[key];

  // 2. Le endpoint contient "microservice.action"
  const parts = key.split('.');
  const lastPart = parts[parts.length - 1];

  if (lastPart && dict[lastPart]) {
    return dict[lastPart];
  }

  // 3. Recherche partielle
  const partialMatch = Object.keys(dict).find(
    (k) => key.includes(k) || k.includes(key)
  );

  if (partialMatch) {
    return dict[partialMatch];
  }

  // 4. Recherche dans tous les microservices
  for (const msDict of Object.values(MS_TRANSLATION_MAP)) {
    if (msDict[key]) return msDict[key];

    if (msDict[lastPart]) return msDict[lastPart];
  }

  // 5. Fallback
  return endpoint
    .replace(/[._-]/g, ' ')
    .replace(/^./, (c) => c.toUpperCase());
};

/**
 * Traduit le nom d'un microservice.
 *
 * @param {string} microservice
 * @returns {string}
 *
 * @example
 * translateMicroservice('weather_service')
 * // → "Météo"
 */
export const translateMicroservice = (microservice) => {
  if (!microservice) return '—';

  const normalized = microservice.toLowerCase().trim();

  return (
    MS_LABELS[normalized] ||
    microservice
      .replace(/[._-]/g, ' ')
      .replace(/^./, (c) => c.toUpperCase())
  );
};

/**
 * Traduit une entrée d'activité complète
 * (endpoint + microservice).
 *
 * @param {{ functionality?: string, endpoint?: string, service?: string }} activity
 * @param {string} [fallbackMs]
 * @returns {{ label: string, msLabel: string }}
 *
 * @example
 * translateActivity(
 *   { functionality: 'auth.login.dashboard' },
 *   'auth'
 * )
 *
 * // → {
 * //      label: "Connexion tableau de bord",
 * //      msLabel: "Authentification"
 * //    }
 */
export const translateActivity = (activity, fallbackMs = '') => {
  const raw =
    activity?.functionality ||
    activity?.endpoint ||
    activity?.service ||
    '';

  // Normalise en lowercase pour matcher les clés des dictionnaires
  const rawNorm = raw.toLowerCase().trim();

  // Détecte le microservice depuis le préfixe "ms.endpoint"
  const dotIndex = rawNorm.indexOf('.');

  const msFromRaw =
    dotIndex !== -1
      ? rawNorm.slice(0, dotIndex)
      : '';

  const epFromRaw =
    dotIndex !== -1
      ? rawNorm.slice(dotIndex + 1)
      : rawNorm;

  const ms =
    msFromRaw ||
    fallbackMs.toLowerCase().trim() ||
    '';

  return {
    label: translateEndpoint(
      epFromRaw || rawNorm,
      ms
    ),

    msLabel: translateMicroservice(
      ms || fallbackMs
    ),
  };
};

export default {
  translateEndpoint,
  translateMicroservice,
  translateActivity,
  MS_LABELS,
};